// @flow
import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { Row, Col, Button, Card } from 'antd';
import product1 from '../../static/images/membership01.png';
import product2 from '../../static/images/1on1Mentoring Package.png';
import { StyledMember, StyledShopCard } from './style'
import ApiService from '../../actions/apiService';
const { Meta } = Card;

class Shop extends Component<Props> {
  
  state = {
    isLoading: true,
    isFreeTrialVisible: false,
  }
  
  async componentWillMount() {
    const data = await ApiService.getFreeTrialVisible();
    if (data) {
      this.setState({
        isLoading: false,
        isFreeTrialVisible: data
      })
    } else {
      this.setState({
        isLoading: false,
      })
    }
  }

  handleAddtoCart = () =>{
    this.props.history.push({
      pathname: '/shop/1on1mentoring',
      state: {
        packageId: 1,
      }
    })
  }
  
  handleAddtoCartFreeTrial = () =>{
    this.props.history.push({
      pathname: '/shop/freetrial',
      state: {
        packageId: 4,
      }
    })
  }

  handleSelectOption = () =>{
    this.props.history.push({
      pathname: '/shop/membershipmonthly',
      state: {
        packageId: 2,
      }
    })
  }

  render() {
    const { isLoading, isFreeTrialVisible } = this.state;
    return (
      <StyledContent>
        <StyledShopCard title="Packages" bordered={false} loading={isLoading}>
          <Row gutter={16}>
            <Col sm={8} xs={24}>
              <StyledMember>
                <Card bordered={false}
                      hoverable
                      cover={<img alt={product1} src={product1}/>}>
                  <Meta title="1 on 1 Mentoring Package"/>
                  <p className="price-title">$2,995.00</p>
                  <Button type="primary" onClick={this.handleAddtoCart}>Add to cart</Button>
                </Card>
              </StyledMember>
            </Col>

            <Col sm={8} xs={24}>
              <StyledMember>
                <Card bordered={false}
                      hoverable
                      cover={<img alt={product2} src={product2}/>}>
                  <Meta title="Membership"/>
                  <p className="price-title">
                    <span className='month'>From:</span>$129.95
                    <span className='month'>/month</span>
                  </p>
                  <Button type="primary" onClick={this.handleSelectOption}>Select options</Button>
                </Card>
              </StyledMember>
            </Col>
            {
              isFreeTrialVisible &&
              <Col sm={8} xs={24}>
                <StyledMember>
                    <Card bordered={false}
                          hoverable
                          cover={<img alt={product2} src={product2}/>}>
                      <Meta title="Free Trial"/>
                      <p className="price-title">$0.00</p>
                      <Button type="primary" onClick={this.handleAddtoCartFreeTrial}>Add to cart</Button>
                    </Card>
                </StyledMember>
              </Col>
            }
          </Row>

        </StyledShopCard>
      </StyledContent>
    )
  }
}

export default Shop



// WEBPACK FOOTER //
// ./src/components/shop-pages/index.js